import React, { useEffect, useRef, useState } from "react";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { rowEndStyle } from "services/constants/Styles";
import { useDispatch } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { Edit } from "@mui/icons-material"; //Delete,
import { useSelector } from "react-redux";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { userGroupSearchKey } from "pages/Administration/AdministrationHeaders";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import {
  scrollTop,
  tableRowSx,
  tableCellFontSize,
  themes,
} from "services/constants";
export const UserGroup = ({ setScreenNavigation, setEditUserGroupDetails }) => {
  const dispatch = useDispatch();
  const [listViewPage, setListViewPage] = useState(0);
  const [firstTimeTrigger, setFristTimeTrigger] = useState(true);
  const [userGroupData, setUserGroupData] = useState([]);
  const tableContainerRef = useRef(null);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const { result: useGroupDetails, loading } = useFetch(
    `${domain}user-group/details/`
  );

  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Roles & User Group",
    "User Group"
  );

  useEffect(() => {
    if (!loading && firstTimeTrigger) {
      setUserGroupData(useGroupDetails);
      setFristTimeTrigger(false);
    }
  }, [firstTimeTrigger, loading, useGroupDetails]);

  const handleChangePage = (event, newPage) => {
    setListViewPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setListViewPage(0);
  };

  useEffect(() => {
    scrollTop(tableContainerRef);
  }, [listViewPage]);

  useEffect(() => {
    const filteredResults = useGroupDetails.filter((item) =>
      userGroupSearchKey.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setUserGroupData(filteredResults);
  }, [globalSearchValue, firstTimeTrigger, useGroupDetails]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.TableContainer
        ref={tableContainerRef}
        sx={{ m: 1, width: "100%", maxHeight: 780 }}
      >
        <Mui.Table className="border">
          <Mui.TableHead
            sx={{
              backgroundColor: themes.primary,
              position: "sticky",
              top: -1,
              zIndex: 10,
            }}
          >
            <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                User Group Name
              </Mui.TableCell>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Company
              </Mui.TableCell>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Role
              </Mui.TableCell>
              <Mui.TableCell
                sx={{
                  color: themes.headLine,
                  fontWeight: "bold",
                  fontSize: tableCellFontSize,
                }}
              >
                Action
              </Mui.TableCell>
            </Mui.TableRow>
          </Mui.TableHead>
          <Mui.TableBody>
            {userGroupData.length === 0 ? (
              <InfoMessage dataLength={useGroupDetails} />
            ) : (
              userGroupData
                ?.slice(
                  listViewPage * rowsPerPage,
                  listViewPage * rowsPerPage + rowsPerPage
                )
                ?.map((item, index) => (
                  <Mui.TableRow
                    maxWidth="xl"
                    align="left"
                    sx={{
                      cursor: "pointer",
                      "& .MuiTableCell-root": {
                        height: "10px",
                        padding: "3px 15px",
                      },
                    }}
                  >
                    <Mui.TableCell>
                      <Mui.Typography>{item?.name}</Mui.Typography>
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <Mui.Grid container>
                        {item?.assignments?.map((data, index) => (
                          <Mui.Grid>
                            {data?.company_name}
                            {index + 1 === item?.assignments?.length
                              ? null
                              : ","}
                          </Mui.Grid>
                        ))}
                      </Mui.Grid>
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <Mui.Grid container>
                        {item?.assignments?.map((data, index) => (
                          <Mui.Grid>
                            {data?.role_name}
                            {index + 1 === item?.assignments?.length
                              ? null
                              : ","}
                          </Mui.Grid>
                        ))}
                      </Mui.Grid>
                    </Mui.TableCell>
                    <Mui.TableCell>
                      <Mui.IconButton
                        onClick={() => {
                          if (check_access) {
                            dispatch(setGlobalSearchValue(""));
                            setEditUserGroupDetails(item);
                            setScreenNavigation("Edit User Group");
                          } else {
                            showToast(
                              "error",
                              "Access denied: You are not authorized to edit user group"
                            );
                          }
                        }}
                      >
                        <Edit />
                      </Mui.IconButton>
                      &nbsp;
                      {/* <Mui.IconButton
                        onClick={() => {
                          deleteGroupDetails();
                        }}
                      >
                        <Delete />
                      </Mui.IconButton> */}
                    </Mui.TableCell>
                  </Mui.TableRow>
                ))
            )}
          </Mui.TableBody>
        </Mui.Table>
      </Mui.TableContainer>
      <Mui.Grid container sx={{ ...rowEndStyle }}>
        {userGroupData.length > 25 && (
          <Mui.TablePagination
            className="custom-pagination"
            component="div"
            rowsPerPageOptions={[25, 50, 75, 100]}
            count={userGroupData.length}
            rowsPerPage={rowsPerPage}
            page={listViewPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </Mui.Grid>
    </React.Fragment>
  );
};
